import React from 'react'
import { Spinner } from "react-bootstrap";
import { Link, Navigate } from "react-router-dom";

import Back from 'shared/assets/images/svg/back_blue.svg'
import Input from 'shared/component/inputFields'


const verifiedPassword = () => {

  return (
    <div className='login verifiedPassword'>
      <div className='container'>
        <div className='row'>
          <div className='col-lg-5 mx-auto'>
            <form onSubmit={e => {
              e.preventDefault();
            }} className='box-login'>
              <div className='page-header'>
                <div className='header-info'>
                  <Link to="/"><img src={Back} alt="" /></Link>
                  <h1 className='title'>CHANGE PASSWORD</h1>
                </div>
              </div>
              <Input type="text" label="email" readonly value="ali.mahmoud@dexef.com" />
              <Input type="password" label="password" />
              <Input type="password" label="confirm password" />

              <button className='btn-blue col-12' type='submit'>  Sign In</button>

            </form>
          </div>
        </div>
      </div>
    </div>
  )
}

export default verifiedPassword